export enum ProgramRequestStatus {
  Opened = 1,
  SubmittedASOO = 2,
  HarmonizationASOO = 3,
  UnlockedASOO = 4,
  CancelledASOO = 5,
  Evaluated = 6,
  RejectedASOO = 7,
  SentMZO = 8,
  SubmittedMZO = 9,
  // HarmonizationMZO = 10,
  ConsentMZO = 11,
  UnlockedMZO = 12,
  CancelledMZO = 13,
  Approved = 14,
  Rejected = 15,
  RejectedHarmonizationASOO = 16,
  ArchivedASOO = 17,
  ArchivedMZO = 18,
  ConsentASOO = 19,
  Paused = 20,
  PausedMZOM = 21,
  HarmonizationUnlockedASOO = 22 
}